module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index-ftb-modules.json
// module id = 247
// module chunks = 60335399758886 257404837723318